window.addEventListener("load", function () {
  const defaultSwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    speed: 1000,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: false,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      641: {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      1025: {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    },
  };

  const archiveSwiperOptions = {
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      320: {
        spaceBetween: 15,
        slidesPerView: 1,
        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: 1,
          sticky: false,
        },
      },
      641: {
        spaceBetween: 15,
        slidesPerView: 1,
        freeMode: {
          enabled: true,
          momentum: true,
          momentumRatio: 1,
          sticky: false,
        },
      },
      1025: {
        spaceBetween: 30,
        slidesPerView: 2.5,
        freeMode: false,
      },
    },
  };

  const swiperOptions = document.body.classList.contains("archive")
    ? archiveSwiperOptions
    : defaultSwiperOptions;

  const swiper = new Swiper(".image-slide-with-text-slider", swiperOptions);
});
